import { render, staticRenderFns } from "./cover.vue?vue&type=template&id=48fe7e4c&"
import script from "./cover.vue?vue&type=script&lang=ts&"
export * from "./cover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports